<!-- Sidebar -->
@if (deviceType.isDesktop) {
  <app-main-menu></app-main-menu>
}
<!-- #Sidebar -->

<!-- Content -->
<router-outlet name="dashboard"></router-outlet>
